import { render, staticRenderFns } from "./guideExercise.vue?vue&type=template&id=71005413&scoped=true&"
import script from "./guideExercise.vue?vue&type=script&lang=js&"
export * from "./guideExercise.vue?vue&type=script&lang=js&"
import style0 from "./guideExercise.vue?vue&type=style&index=0&id=71005413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71005413",
  null
  
)

export default component.exports